// eslint-disable-next-line @nx/enforce-module-boundaries
import { UDFCellRendererParams, UDFChoiceCellRendererParams, UDFDateCellRendererParams } from '@ddv/data-grid';

export function isUDFChoiceCellRendererParams(data: unknown): data is UDFChoiceCellRendererParams {
    return isUDFCellRendererParams(data) && data.userDefinedFieldType === 'choice';
}

export function isUDFDateCellRendererParams(data: unknown): data is UDFDateCellRendererParams {
    return isUDFCellRendererParams(data) && data.userDefinedFieldType === 'date';
}

function isUDFCellRendererParams(data: unknown): data is UDFCellRendererParams {
    return Object.prototype.hasOwnProperty.call(data, 'canEditUdf');
}
